/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryAllergiesViewerAliases {
  ACTION_INACTIVATE_HEALTH_HISTORY_ALLERGIES = 'action-inactivate-health-history-allergies',
  ACTION_NEW_HEALTH_HISTORY_ALLERGIES = 'action-new-health-history-allergies',
  ACTION_REVIEW_HEALTH_HISTORY_ALLERGIES = 'action-review-health-history-allergies',
  CHECKBOX_DENIES_ALLERGIES = 'checkbox-denies-allergies',
  CHECKBOX_PATIENT_ALERTS = 'checkbox-patient-alerts',
  CHECKBOX_PROBLEMS_LIST = 'checkbox-problems-list',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_ACTIVE_INGREDIENT = 'field-active-ingredient',
  FIELD_APPROACH = 'field-approach',
  FIELD_CAUSATIVE_AGENT = 'field-causative-agent',
  FIELD_CLASSIFICATION = 'field-classification',
  FIELD_CONDITION = 'field-condition',
  FIELD_DATE_TYPE = 'field-date-type',
  FIELD_DCB = 'field-dcb',
  FIELD_DENIES_ALLERGIES = 'field-denies-allergies',
  FIELD_END_DATE = 'field-end-date',
  FIELD_FAMILY = 'field-family',
  FIELD_HIGHLIGHT_INTENSITY_SEVERITY = 'field-highlight-intensity-severity',
  FIELD_LAST_DATE = 'field-last-date',
  FIELD_MATERIAL_MEDICINE = 'field-material-medicine',
  FIELD_MATERIAL_MEDICINE_CLASS = 'field-material-medicine-class',
  FIELD_NOTES = 'field-notes',
  FIELD_ORIGIN = 'field-origin',
  FIELD_PATIENT_ALERTS = 'field-patient-alerts',
  FIELD_PROBLEMS_LIST = 'field-problems-list',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_REACTION_TYPE = 'field-reaction-type',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_REVIEW_DATE = 'field-review-date',
  FIELD_REVIEW_USER = 'field-review-user',
  FIELD_SECURITY_LEVEL = 'field-security-level',
  FIELD_START_DATE = 'field-start-date',
  FIELD_UNREGISTERED_CAUSATIVE_AGENT = 'field-unregistered-causative-agent',
  FORM_HEALTH_HISTORY_ALLERGIES_VIEWER = 'form-health-history-allergies-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_HEALTH_HISTORY_ALLERGIES_VIEWER = 'layout-health-history-allergies-viewer',
  PANEL_FORM = 'panel-form',
  RADIO_GROUP_CLASSIFICATION = 'radio-group-classification',
  RADIO_GROUP_CONDITION = 'radio-group-condition',
  RADIO_GROUP_HIGHLIGHT_INTENSITY_SEVERITY = 'radio-group-highlight-intensity-severity',
  TEXT_ACTIVE_INGREDIENT = 'text-active-ingredient',
  TEXT_APPROACH = 'text-approach',
  TEXT_AREA_NOTE = 'text-area-note',
  TEXT_CAUSATIVE_AGENT = 'text-causative-agent',
  TEXT_DATE_TYPE = 'text-date-type',
  TEXT_DCB = 'text-dcb',
  TEXT_END_DATE = 'text-end-date',
  TEXT_FAMILY = 'text-family',
  TEXT_LAST_DATE = 'text-last-date',
  TEXT_MATERIAL_MEDICINE = 'text-material-medicine',
  TEXT_MATERIAL_MEDICINE_CLASS = 'text-material-medicine-class',
  TEXT_ORIGIN = 'text-origin',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_REACTION_TYPE = 'text-reaction-type',
  TEXT_RECORD_DATE = 'text-record-date',
  TEXT_REVIEW_DATE = 'text-review-date',
  TEXT_REVIEW_USER = 'text-review-user',
  TEXT_SECURITY_LEVEL = 'text-security-level',
  TEXT_START_DATE = 'text-start-date',
  TEXT_UNREGISTERED_CAUSATIVE_AGENT = 'text-unregistered-causative-agent',
}
export { HealthHistoryAllergiesViewerAliases };
